import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-visual-map-with-proj-statistic',
  templateUrl: './visual-map-with-proj-statistic.component.html',
  styleUrls: ['./visual-map-with-proj-statistic.component.scss']
})
export class VisualMapWithProjStatisticComponent implements OnInit {

  categories: { title: string; list: any; }[] = [];
  @Input() public projects = new EventEmitter();
  @Input() public compositeDesign = new EventEmitter();
  @Input() public unika = new EventEmitter();
  @Input() public searchGeneralLook = new EventEmitter();
  @Input() public showProperties = new EventEmitter();
  @Output() public showSearchResults = new EventEmitter();
  @Input() public visualMap = new EventEmitter();
  searchTerm;
  ifShowProperties: boolean = false;
  buildingTitle: string = "";
  freeStatusCounter: number = 0;
  waitingStatusCounter: number = 0;
  soldStatusCounter: number = 0;
  urlSwitcher: any;
  compId: string;
  iframeElement: any;

  constructor(public dataService: DataService, private router: Router, private route: ActivatedRoute,) {
    const id = route.snapshot.paramMap.get('id');
    this.compId = id;
  }

  ngOnInit(): void {
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    window.addEventListener("message", this.receiveMessage.bind(this), false);
    let projects = [];
    setTimeout(() => {
      test(this.projects);
      function test(proj) {
        projects = proj;
      }
      if (this.showProperties) {
        let addBuilding = (proj => {
          this.dataService.getItemsByProjId(proj.id).subscribe(buildList => {
            proj.buildings = [];
            console.log(buildList);
            if (buildList.length > 0) {
              let statusCounter = this.getFlats(buildList);
              proj.statusCounter = statusCounter;
              proj.buildings = buildList;
            }
          })
        })
        projects.map((proj, index) => {
          addBuilding(proj);
        });
        this.addCategoryTitles(projects);
      } else {
        this.addCategoryTitles(this.projects);

      }
    }, 2000);
  }


  receiveMessage(event) {
    if (event.origin === 'https://topeye.club') {
      setTimeout(() => {
        this.showStatisticInfo();
      }, 2000);
    }
  }


  showStatisticInfo() {
    let data = [];
    let projStatus
    this.categories.forEach(category => {
      category.list.forEach(proj => {
        if (proj.statusCounter) {
          data.push( {
            title: proj.title,
            free: proj.statusCounter.free,
            waiting: proj.statusCounter.waiting,
            sold: proj.statusCounter.sold
          })
        }

      })
    })
    this.send(data);
  }


  send(data) {
    // const url = 'https://topeye.club/';
    // const test = document.getElementsByClassName("da-iframe-map");
    // let test1: HTMLIFrameElement;
    // if (test.length > 0) {
    //   test1 = test[0].getElementsByTagName('iframe')[0];
    // }
    // const win = test1;
    // if (win) {
    //   this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
    //   this.iframeElement.postMessage(JSON.stringify(data), url);
    // }

    postMessageToIframe(data);
  }



  getFlats(buildings) {
    interface StatusCounter {
      free: number;
      waiting: number;
      sold: number;
    };
    let statusCounter: StatusCounter = { free: 0, waiting: 0, sold: 0 };
    let numberOfRoomsArray: any = [];
    const results = buildings.map((building) => {
      this.buildingTitle = building.name;
      return building.floors.map(item => {
        return item.floor.flats.filter((flat) => {
          flat.buildingName = building.name;
          if (flat.status !== "") {
            if (flat.status === 'free' || flat.status === 0) {
              this.freeStatusCounter = this.freeStatusCounter + 1;
              statusCounter.free = statusCounter.free + 1;
            }
            if (flat.status === 'waiting') {
              this.waitingStatusCounter = this.waitingStatusCounter + 1;
              statusCounter.waiting = statusCounter.waiting + 1;
            }
            if (flat.status === 'sold') {
              this.soldStatusCounter = this.soldStatusCounter + 1;
              statusCounter.sold = statusCounter.sold + 1;
            }
          }
          return false;
        });
      })
    });
    console.log(numberOfRoomsArray);
    return statusCounter;
  }

  addCategoryTitles(projects) {

    if (projects) {
      const categoryWithProjects = projects.reduce((acc, proj) => {
        if (!acc[proj.category]) {
          acc[proj.category] = [];
        }
        acc[proj.category].push(proj);
        return acc;
      }, {});

      const categoryWithProjectsArray = Object.keys(categoryWithProjects).map(title => ({
        title: title,
        list: categoryWithProjects[title]
      }))

      this.categories = categoryWithProjectsArray;
    }
    // this.showStatisticInfo();
  }


  viewItemDetails(event, item) {
    const segment = this.route.snapshot.url;
    let link = this.urlSwitcher + this.route.snapshot.params.id + '/' + item.uid;
    this.dataService.openProjectClickOnMarker(item);
    this.dataService.saveRemoveMenu('false');
    window.open(link, '_blank')
  }
  showResoultBlock() {
    this.showSearchResults.emit('true');
  }
  closeSearch() {
    this.showSearchResults.emit('false');
  }
  goToBuilding(buildingUid, project) {
    this.dataService.saveRemoveMenu('false');
    const link = '/company/u/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid
    window.open(link, '_blank')
  }

}
